/* istanbul ignore file */
import React from 'react';
import { CreateBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import VacancyGroupBreadcrumbs from 'domain/recruiting/newVacancy/show/vacancyGroup/shared/VacancyGroupBreadcrumbs';

const CreateVacancyPublicationBreadcrumbs = () => {
  return (
    <VacancyGroupBreadcrumbs>
      <CreateBreadcrumbItem entity="Vacancy Publication" />
    </VacancyGroupBreadcrumbs>
  );
};

export default CreateVacancyPublicationBreadcrumbs;
